<script lang="ts">
	import Section from "@components/Section.svelte";
	import ContentBlocks from "@components/common/ContentBlocks.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import type { ReferenceDetailProps } from "./ReferenceDetailProps.js";

	const { reference }: ReferenceDetailProps = $props();

	const perex = reference.caseStudy?.perex ?? reference.defaultDescription;
	const blocks = reference.caseStudy?.content ?? [];
</script>

<Layout>
	<Section gridHeadline="container-start-2 container-end-10" gridChildren="container-start-2 container-end-9">
		{#snippet headline()}
			{#if perex}
				<h2 class="text-[1.25rem] md:text-xl lg:text-2xl font-[900] mb-4 text-fstonyx">
					<Formatted text={perex} />
				</h2>
			{/if}
		{/snippet}

		<ContentBlocks {blocks} class="ckeditor-content-reference" />
	</Section>
</Layout>
